import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiComicFilter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-comic-filter',
			name: 'AI Comic Filter: Turn Image To Comic Book Style Art | Lift',
			description:
				"Turn your photos into comic book art instantly with Lift's AI comic filter. No watermark. Upload a photo and become a comic hero.",
			url: 'https://liftapp.ai/ai-comic-filter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-comic-filter#product' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#howto' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#benefits' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#faq' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-comic-filter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-comic-filter#product',
			name: 'AI Comic Generator Online',
			description:
				'Instantly transform yourself, friends, or favorite moments into epic comic book art — no drawing skills needed. Perfect for avatars, social media posts, or just showing off your unique, comic-ready look!',
			url: 'https://liftapp.ai/ai-comic-filter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-comic-filter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Apply the AI comic filter',
					text: 'Instantly convert your photo into Comic Book style',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-comic-filter#benefits',
			name: 'Who can benefit from AI Comic Filter?',
			description:
				"Lift's AI Comic Filter is useful for comic fans, artists, content creators, and social media users who want to transform photos into comic book style art.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Comic and pop culture fans — see yourself as a comic hero without learning to draw',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Aspiring comic artists can visualize character designs without manual illustration',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators can generate scroll-stopping visuals with authentic comic aesthetics',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Social media users can transform selfies into shareable comic-style portraits',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Comic Filter Benefits Illustration',
				description: 'Various users enjoying AI comic-style art',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-comic-filter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Comic Filter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Comic Filter is a online tool that converts your photos into comic book style art instantly. Upload any image and watch it transform into bold, illustrated graphics — perfect for social media avatars, story posts, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: "How does Lift's comic book filter work?",
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Our AI analyzes your photo's structure, lighting, and features, then reimagines it in authentic comic book style with vibrant colors, bold outlines, and graphic shading. The transformation is automatic — no drawing skills or manual editing needed.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I turn any photo into comic book art?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift's AI comic filter works with portraits, group photos, pets, selfies, and any image type. Whether you want to convert a real picture into a comic or create an epic comic book filter for your latest post, the AI adapts to your content while maintaining recognizable features.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images created with Lift's comic filter can be exported without a watermark on the Pro plan. Download them in high-res PNG or JPG format — ready for Instagram, TikTok, profile pictures, or printing.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-comic-filter#why-lift',
			name: "Why Lift's AI Comic Filter stands out",
			description:
				"Lift's AI Comic Filter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why Lift AI Comic Filter Stands Out',
				description:
					'AI comic filter comparison showcasing quality and rendering.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-comic-filter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-comic-filter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Comic Filter',
					item: 'https://liftapp.ai/ai-comic-filter',
				},
			],
		},
	],
};
